import { useState } from 'react'
import {
    UserInfoLabel,
    FlexLayout,
    UserInfoText,
    ChangeButton,
    EditActions,
    Submit,
    Cancel,
    UserInfoInput,
    Select,
    Option,
} from './userInfoItemElements'
import { useDispatch } from 'react-redux'
import { updateProfile } from '../../../store/reducer/userSlice'
import { ErrorMsg } from '../../../components/common/ErrorMsg'

const UserInfoItem = ({ label, text, select, options, password, field, number }) => {
    const [edit, setEdit] = useState(false)
    const [info, setInfo] = useState(password ? '':text)
    const [confirm, setConfirm] = useState('')
    const dispatch = useDispatch()
    const [error, setError] = useState(false)

    const showEdit = () => setEdit(true)

    const hideEdit = () => {
        setEdit(false)
        setInfo(password ? '':text)
        setError(false)
    }

    const handleInputChange = e => setInfo(e.target.value)

    const handleConfirmChange = e => setConfirm(e.target.value)

    const handleSubmit = async () => {
        if(!info.trim()) return setError(`Vui lòng nhập ${label}`)
        
        if(password) {
            if(info.trim().length < 6) return setError(`Mật khẩu phải trên 6 kí tự`)
            else if(info.trim() !== confirm.trim()) return setError('Mật khẩu nhập lại không đúng')
        }
        
        if(number) {
            const reg = new RegExp('^[0-9]+$');
            if(!reg.test(info)) return setError(`${label} chỉ được nhập số`)
        }

        await dispatch(updateProfile({ [field]: info.trim() }))
        setEdit(false)
        setInfo(password ? '':info.trim())
    }


    return (
        <>
            <UserInfoLabel>{edit && password ? label+' mới':label}</UserInfoLabel>
            {edit ? <>
                <FlexLayout style={{width: '470px'}}>
                    {select ? 
                    <Select onChange={handleInputChange} value={info}>
                        {options.map(option => <Option key={option.value} value={option.value}>{option.label}</Option>)}
                    </Select>:
                        <UserInfoInput type={password ? 'password':'text'} onChange={handleInputChange} value={info} />
                    }
                </FlexLayout>
                {password && <>
                    <UserInfoLabel>Nhập lại mật khẩu mới</UserInfoLabel>
                    <UserInfoInput type='password' onChange={handleConfirmChange} value={confirm} />
                </>}
                {error && <ErrorMsg>{error}</ErrorMsg>}
                <EditActions>
                    <Submit onClick={handleSubmit}>Lưu thay đổi</Submit>
                    <Cancel onClick={hideEdit}>Hủy bỏ</Cancel>
                </EditActions>
            </>:<>
                <FlexLayout>
                    <UserInfoText>{text}</UserInfoText>
                    <ChangeButton onClick={showEdit}>Thay đổi</ChangeButton>
                </FlexLayout>
            </>}
        </>
    )
}

export default UserInfoItem
